import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBreedingFarmStatus } from "../../../../models/handBooks/breedingFarmStatus";
import { useAddBreedingFarmStatusMutation, useDeleteBreedingFarmStatusMutation, useEditBreedingFarmStatusMutation } from "../../../../redux/api/handBooksApi/breedingFarmStatusApi";

const useBreedingFarmStatus = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addBreedingFarmStatus] = useAddBreedingFarmStatusMutation();
    const [deleteBreedingFarmStatus] = useDeleteBreedingFarmStatusMutation();
    const [editBreedingFarmStatus] = useEditBreedingFarmStatusMutation();


    async function onAddBreedingFarmStatus(newBreedingFarmStatus: EntBreedingFarmStatus): Promise<boolean> {
        try {
            let status: boolean = false;
            await addBreedingFarmStatus(newBreedingFarmStatus).then((response: any) => {
                if (response.error !== undefined) {
                    
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteBreedingFarmStatus(breedingFarmStatus: EntBreedingFarmStatus) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteBreedingFarmStatus(breedingFarmStatus.id).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditBreedingFarmStatus(editedBreedingFarmStatus: EntBreedingFarmStatus): Promise<boolean> {
        try {
            let status: boolean = false;
            await editBreedingFarmStatus(editedBreedingFarmStatus).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddBreedingFarmStatus, onDeleteBreedingFarmStatus, onEditBreedingFarmStatus }

}
export { useBreedingFarmStatus };

